var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41459 12.0006L7.36433 7.05086C7.75486 6.66033 7.75486 6.02717 7.36433 5.63664C6.97381 5.24612 6.34064 5.24612 5.95012 5.63664L0.293265 11.2935C-0.097259 11.684 -0.097259 12.3172 0.293265 12.7077L5.95012 18.3646C6.34064 18.7551 6.97381 18.7551 7.36433 18.3646C7.75486 17.974 7.75486 17.3409 7.36433 16.9504L2.41459 12.0006Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.1b5e69523bb67a2f6a529900c49fc3eb.svg";
export { ForwardRef as ReactComponent };